import axios from 'axios'
import { host } from '../../configuraciones'
import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'


const dataInicial = {
    lotes: []
}

let token = ''

//DEFINICIÓN DE MÉTODOS *********************************************************************************************

const INICIAR_SESION = 'INICIAR_SESION'
const GET_ALL_LOTES = 'GET_ALL_LOTES'

//*******************************************************************************************************************


//METODOS
export const iniciarSesion = createAsyncThunk(
    INICIAR_SESION,
    async () => {
        try {
            const fullUrl = `https://ralew.com.mx/syscrm/backend/api/auth/iniciaSesion`
            const res = await axios.post(fullUrl, {
                "password": "ceN37@_2023",
                "usuario": "crm_cliente@gmail.com"
            }).then((response) => {
                token = response.data.token
            })
            return res
        } catch (error) {
            console.log(error);
        }
    }
)



export const obtenerLotesRebeca = createAsyncThunk(
    GET_ALL_LOTES,
    async () => {
        try {
            const fullUrl = `https://ralew.com.mx/syscrm/backend/api/cliente/getlstLotesGranelAlmacen`;

            const res = await fetch(fullUrl, {
                method: 'GET',
                headers: {
                    'Authorization': `Bearer ${token}`,
                    'Content-Type': 'application/json',
                },
            });

            const data = await res.json();
            return data.response; // Devuelve los datos obtenidos de la API
        } catch (error) {
            console.log(error);
            throw error; // Lanza el error para que sea manejado por createAsyncThunk
        }
    }
);


//****************************************************************************************************************
//EXPORTS DE MÉTODOS

export const metodosRebecaUISlice = createSlice({

    name: 'metodosRebecaUISlice',
    initialState: dataInicial,
    reducers: {
    },
    extraReducers: {
        [iniciarSesion.fulfilled]: (state, { payload }) => {
        },
        [obtenerLotesRebeca.fulfilled]: (state, { payload }) => {
            state.lotes = payload
        },
    },

})

export const { } = metodosRebecaUISlice.actions
export const RebecaUIReducer = metodosRebecaUISlice.reducer